import { ReactNode } from 'react';
import { PortalHeader } from './PortalHeader';
import { PortalNavigation } from './PortalNavigation';
import { PortalThemeProvider } from '@/contexts/PortalThemeContext';

interface PortalLayoutProps {
  children: ReactNode;
}

export function PortalLayout({ children }: PortalLayoutProps) {
  return (
    <PortalThemeProvider>
      <div className="min-h-screen flex flex-col bg-background">
        <PortalHeader />
        <PortalNavigation />
        <main className="flex-1 p-6">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
        <footer className="border-t bg-card py-4 px-6 text-center text-sm text-muted-foreground">
          <p>Powered by CRM Platform | Need help? Contact your project manager</p>
        </footer>
      </div>
    </PortalThemeProvider>
  );
}
